import { ETHER_MAIN, POLYGON_AMOY, POLYGON_MAIN } from '@/lib/common/name-space';

export const explorerUrlFilter = (chainId: number) => {
  switch (chainId) {
    case ETHER_MAIN:
      return 'https://etherscan.io';
    case POLYGON_MAIN:
      return 'https://polygonscan.com';
    case POLYGON_AMOY:
      return 'https://amoy.polygonscan.com';
    default:
      return 'https://polygonscan.com';
  }
};
